import {tooltipInteraction} from '../events'
import withSnowplowLifecycle from './withSnowplowLifecycle'

const withTooltipInteraction = (WrappedComponent, options = null) => withSnowplowLifecycle(WrappedComponent, tooltipInteraction, options)

export default withTooltipInteraction
